import { AxiosError } from "axios";

import { ApiErrorResponse } from "@/api/__generated__/schemas";

export const getApiErrorCode = (error: unknown): string | null => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    return data?.error?.code ?? null;
  }
  return null;
};

/**
 * The server's human-readable message. Worth surfacing when no translated
 * string is mapped for the code — see DEV-4588, where an unmapped 400/404
 * showed only a generic "Failed to save" and hid the real cause.
 */
export const getApiErrorMessage = (error: unknown): string | null => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    const message = data?.error?.message;
    return typeof message === "string" && message.trim() ? message : null;
  }
  return null;
};

export const getApiErrorDetails = (error: unknown): Record<string, unknown> | null => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    const details = (data?.error as { details?: unknown } | undefined)?.details;
    return details && typeof details === "object" ? (details as Record<string, unknown>) : null;
  }
  return null;
};
